const initialState = {
    dataComboProv: [],
    dataComboKab: [],
    dataComboKec: [],
    dataComboDesa: [],
    dataComboJenisBantuan: [],
    dataComboPenghasilanTetap: [],
    dataComboStatusKk: [],
    dataComboJenisKelamin: [],
    dataComboAgama: [],
    dataComboJenisPendidikan: [],
    dataComboWarga: [],
    dataComboJenisGoldar: [],
    dataComboJenisPekerjaan: [],
    dataComboStatusKawin: [],
    dataComboStatusKkNik: [],
    dataComboRole: [],

    dataComboIndicator: [],
    dataComboIndicatorDet: [],
    dataComboMasterTable: [],
    dataComboAppl: [],
    dataComboApplTask: [],
    dataComboApplTaskParent: [],
    dataComboAgency: [],
    dataComboSector: [],
    dataComboGeoportalTypeKey: [],
    dataComboAffair: [],
    dataComboFrequency: [],
    dataComboScope: [],
    dataComboLicense: [],
    dataComboTag: [],
    dataComboCategory: [],
    dataComboDatasetType: [],
    dataComboFieldType: [],
    dataComboPublicationDatasetType: [],
    dataComboPublicationDocumentType: [],
    dataComboTahun: [],

    dataComboSemester: [],
    dataComboKwartal: [],
    dataComboTriwulan: [],
    dataComboBulan: [],
};

const comboReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'DATA_COMBO_PROV':
            return { ...state, dataComboProv: action.payload }
        case 'DATA_COMBO_KAB':
            return { ...state, dataComboKab: action.payload }
        case 'DATA_COMBO_KEC':
            return { ...state, dataComboKec: action.payload }
        case 'DATA_COMBO_DESA':
            return { ...state, dataComboDesa: action.payload }
        case 'DATA_COMBO_JENIS_BANTUAN':
            return { ...state, dataComboJenisBantuan: action.payload }
        case 'DATA_COMBO_PENGHASILAN_TETAP':
            return { ...state, dataComboPenghasilanTetap: action.payload }
        case 'DATA_COMBO_STATUS_KK':
            return { ...state, dataComboStatusKk: action.payload }
        case 'DATA_COMBO_JENIS_KELAMIN':
            return { ...state, dataComboJenisKelamin: action.payload }
        case 'DATA_COMBO_AGAMA':
            return { ...state, dataComboAgama: action.payload }
        case 'DATA_COMBO_JENIS_PENDIDIKAN':
            return { ...state, dataComboJenisPendidikan: action.payload }
        case 'DATA_COMBO_WARGA':
            return { ...state, dataComboWarga: action.payload }
        case 'DATA_COMBO_JENIS_GOLDAR':
            return { ...state, dataComboJenisGoldar: action.payload }
        case 'DATA_COMBO_JENIS_PEKERJAAN':
            return {...state, dataComboJenisPekerjaan: action.payload }
        case 'DATA_COMBO_STATUS_KAWIN':
            return {...state, dataComboStatusKawin: action.payload }
        case 'DATA_COMBO_STATUS_KK_NIK':
            return { ...state, dataComboStatusKkNik: action.payload }
        case 'DATA_COMBO_ROLE':
            return {...state, dataComboRole: action.payload }
        
        case 'DATA_COMBO_INDICATOR':
            return {...state, dataComboIndicator: action.payload }
        case 'DATA_COMBO_INDICATOR_DET':
            return {...state, dataComboIndicatorDet: action.payload }
        case 'DATA_COMBO_MASTER_TABLE':
            return {...state, dataComboMasterTable: action.payload }
        case 'DATA_COMBO_APPL':
            return {...state, dataComboAppl: action.payload }
        case 'DATA_COMBO_APPL_TASK':
            return {...state, dataComboApplTask: action.payload }
        case 'DATA_COMBO_APPL_TASK_PARENT':
            return {...state, dataComboApplTaskParent: action.payload }

        case 'DATA_COMBO_AGENCY':
            return {...state, dataComboAgency: action.payload }
        case 'DATA_COMBO_SECTOR':
            return {...state, dataComboSector: action.payload }
        case 'DATA_COMBO_GEOPORTAL_TYPE_KEY':
            return {...state, dataComboGeoportalTypeKey: action.payload }
        case 'DATA_COMBO_AFFAIR':
            return {...state, dataComboAffair: action.payload }
        case 'DATA_COMBO_FREQUENCY':
            return {...state, dataComboFrequency: action.payload }
        case 'DATA_COMBO_SCOPE':
            return {...state, dataComboScope: action.payload }
        case 'DATA_COMBO_LICENSE':
            return {...state, dataComboLicense: action.payload }
        case 'DATA_COMBO_TAG':
            return {...state, dataComboTag: action.payload }
        case 'DATA_COMBO_CATEGORY':
            return {...state, dataComboCategory: action.payload }
        case 'DATA_COMBO_DATASETTYPE':
            return {...state, dataComboDatasetType: action.payload }
        case 'DATA_COMBO_FIELDTYPE':
            return {...state, dataComboFieldType: action.payload }
        case 'DATA_COMBO_PUBLICATION_DATASETTYPE':
            return {...state, dataComboPublicationDatasetType: action.payload }
        case 'DATA_COMBO_PUBLICATION_DOCUMENTTYPE':
            return {...state, dataComboPublicationDocumentType: action.payload }
        case 'DATA_COMBO_TAHUN':
            return {...state, dataComboTahun: action.payload }
        case 'DATA_COMBO_SEMESTER':
            return {...state, dataComboSemester: action.payload }
        case 'DATA_COMBO_KWARTAL':
            return {...state, dataComboKwartal: action.payload }
        case 'DATA_COMBO_TRIWULAN':
            return {...state, dataComboTriwulan: action.payload }
        case 'DATA_COMBO_BULAN':
            return {...state, dataComboBulan: action.payload }
        default:
            return state
    }
};

export default comboReducer;